export default __webpack_public_path__ + "448a9ee3eed0b1ba9cd2ef33dc3b44f2.png";